export default __webpack_public_path__ + "resources/icons/n330-a8b8.png";